<script lang="ts">
import {defineComponent, onMounted, ref} from 'vue';
import {useTranslationStore, translation} from '~/plugins/store/translations';
import {type MaintenanceResponse, type TranslationList} from "~/types/Utils";
import {useSystemStore} from "~/plugins/store/system";
import MasterLayout from "~/layouts/MasterLayout.vue";
import LoadingDialog from "~/components/utils/LoadingDialog.vue";

export default defineComponent({
  setup() {
    useHead({
      title: 'Xiga | Maintenance',
      meta: [
        {
          name: 'description',
          content: 'Ne cerem scuze pentru neplăcerile create. Site-ul XIGA este momentan în mentenanță și va reveni online în cel mai scurt timp. Vă mulțumim pentru răbdare!'
        }
      ],
    });

    const {$toast} = useNuxtApp();
    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({});
    const systemStore = useSystemStore();
    const maintenanceResponse = ref<MaintenanceResponse | null>(null);
    const showLoadingDialog = ref(false);
    const messageLoadingDialog = ref('');

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      showLoadingDialog.value = true;
      messageLoadingDialog.value = translation(translationList.value.loading, 'Se incarcă...');
      maintenanceResponse.value = await systemStore.fetchMaintenanceStatus();
      if (!maintenanceResponse.value || !maintenanceResponse.value.is_in_maintenance) {
        $toast.error(translation(translationList.value.maintenance, 'Site-ul nu este în mentenanță!'));
        await navigateTo('/');
      }
      showLoadingDialog.value = false;
    });

    return {
      translationList,
      translation,
      maintenanceResponse,
      showLoadingDialog,
      messageLoadingDialog,
    };
  },
  components: {LoadingDialog, MasterLayout},
  data: () => ({}),
});
</script>

<template>
  <master-layout class="static">
    <v-container class="content-container ">
      <v-container fluid class="component-container-1400mw">
        <v-container class="background-ghost-white" style="max-width: 1200px; border-radius: 15px;">
          <loading-dialog :message="messageLoadingDialog" :show-dialog="showLoadingDialog"/>
          <v-card min-height="500" v-if="maintenanceResponse" flat rounded="lg">
            <v-card-title>
              <h1 class="text-center">{{ translation(translationList.maintenance, 'Site-ul este în mentenanță!') }}</h1>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text
                v-if="maintenanceResponse.maintenance && maintenanceResponse.maintenance.start_at && maintenanceResponse.maintenance.end_at">
              <div class="fw-300 fs-36">{{ translation(translationList.maintenance, 'Mentenanța va dura între') }}
                {{ maintenanceResponse.maintenance.start_at }} {{ translation(translationList.maintenance, 'și') }}
                {{ maintenanceResponse.maintenance.end_at }}</div>
            </v-card-text>
          </v-card>
        </v-container>
      </v-container>
    </v-container>
  </master-layout>
</template>

<style scoped>

</style>
